import {
  Skeleton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import { useMemo } from 'react';
import { CollectionPoint } from '../../../../types';
import { useGetBlockForCollectionPoint } from '../../hooks/useGetBlockForCollectionPoint';

type Props = {
  details: CollectionPoint;
};
export const PointDetailsTable = ({ details }: Props) => {
  const { block, isLoading: loadingBlock } =
    useGetBlockForCollectionPoint(details);

  const displayData = useMemo<
    {
      label: string;
      value: string | number;
      loading?: boolean;
    }[]
  >(() => {
    return [
      {
        label: 'Block Assigned',
        value: block?.name ?? 'Unknown',
        loading: loadingBlock,
      },
      { label: 'GPS Strength', value: 'TODO' }, // TODO: How is this determined?
      { label: 'Exposure', value: details.exposure },
      { label: 'Camera ID', value: details.cameraId },
    ];
  }, [block, details, loadingBlock]);

  return (
    <StyledTable>
      <TableBody>
        {displayData?.map(({ label, value, loading }, index) => (
          <TableRow key={`point-data-${index}`}>
            <TableCell>{label}</TableCell>
            <TableCell align='right'>
              {!loading ? value : <Skeleton variant='text' />}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

const StyledTable = styled(Table)({
  background: 'transparent',
  '& .MuiTableRow-root': {
    color: 'white',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
  },
});
